export default __webpack_public_path__ + "static/embla-logo-dark-theme-e0355b1aed42f0a57637d8d8e6c28cda.svg";